import React, { useEffect } from "react";
import PageMetaData from "../../../CustomComponents/PageMetaData/PageMetaData";
import CustomerHeader from "../CustomerHeader/CustomerHeader";
import CustomerSideBar from "../CustomerSideBar/CustomerSideBar";
import { useLocation, useNavigate } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../../assets/toastUtils";
import { useState } from "react";
import NoDataFound from "../../../CustomComponents/NoDataFound/NoDataFound";
import Loader from "../../../CustomComponents/Loader/Loader";
import { formatIndianCurrency, textDateFormatter } from "../../../utils/utils";
import SeeBookingSlider from "../../../CustomComponents/SeeBookingsSlider/SeeBookingsSlider";
import CustomerPackages from "../../CustomerPackages/CustomerPackages";
import styles from "./CustomerBooking.module.scss";
import TourBookings from "../../../CustomComponents/TourBookings/TourBookings";

function CustomerBooking() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialRole = queryParams.get("role") || "profile";
  const [singleBookingData, setSingleBookingData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [allBookingsHotels, setAllBookingsHotels] = useState([]);
  const [allBookingsPackages, setAllBookingsPackages] = useState([]);
  const [allBookingsActivities, setAllBookingsActivities] = useState([]);
  const [allBookingsTransport, setAllBookingsTransport] = useState([]);

  const handleChangeClick = async () => {
    setIsSliderVisible(true);
  };

  // const customerHotelBookingsFetch = () => {
  //   setLoader(true);

  //   fetch(`${process.env.REACT_APP_APP_URL}/api/v1/customers/bookings`, {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${userToken}`,
  //     },
  //   })
  //     .then((response) => response.json())
  //     .then((result) => {
  //       if (result) {
  //         setLoader(false);
  //         // setCustomerBooking(result?.data?.data);
  //         const groupByCategory = result?.data?.data?.reduce(
  //           (group, booking) => {
  //             const { tour_start } = booking;
  //             group[tour_start] = group[tour_start] ?? [];
  //             group[tour_start].push(booking);
  //             return group;
  //           },
  //           {}
  //         );
  //         setLoader(false);

  //         if (groupByCategory) {
  //           setCustomerBooking(groupByCategory);
  //         } else {
  //           setCustomerBooking([]);
  //         }
  //       } else {
  //         setLoader(false);
  //       }
  //     })
  //     .catch((error) => {
  //       setLoader(false);
  //       console.error(
  //         "There was an error fetching the customers booking.",
  //         error
  //       );
  //     });
  // };

  const customerHotelBookingsFetch = async () => {
    setLoader(true);
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${userToken}`,
      Cookie: process.env.REACT_APP_COOKIE,
    };

    const body = JSON.stringify({
      booking_type: "accommodation",
      account_type: "customer",
    });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/customer/bookings/fetch/list`,
        {
          method: "POST",
          headers,
          body,
          redirect: "follow",
        }
      );

      const result = await response.json();
      setAllBookingsHotels(result?.data);
      setLoader(false);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setLoader(false);
    }
  };

  const customerPacakgeBookingsFetch = async () => {
    setLoader(true);
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${userToken}`,
      Cookie: process.env.REACT_APP_COOKIE,
    };

    const body = JSON.stringify({
      booking_type: "package",
      account_type: "customer",
    });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/customer/bookings/fetch/list`,
        {
          method: "POST",
          headers,
          body,
          redirect: "follow",
        }
      );

      const result = await response.json();
      setAllBookingsPackages(result?.data);
      setLoader(false);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setLoader(false);
    }
  };
  const customerActivityBookingsFetch = async () => {
    setLoader(true);
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${userToken}`,
      Cookie: process.env.REACT_APP_COOKIE,
    };

    const body = JSON.stringify({
      booking_type: "activity",
      account_type: "customer",
    });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/customer/bookings/fetch/list`,
        {
          method: "POST",
          headers,
          body,
          redirect: "follow",
        }
      );

      const result = await response.json();
      setAllBookingsActivities(result?.data);
      setLoader(false);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setLoader(false);
    }
  };
  const customerTransportBookingsFetch = async () => {
    setLoader(true);
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${userToken}`,
      Cookie: process.env.REACT_APP_COOKIE,
    };

    const body = JSON.stringify({
      booking_type: "transport",
      account_type: "customer",
    });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/customer/bookings/fetch/list`,
        {
          method: "POST",
          headers,
          body,
          redirect: "follow",
        }
      );

      const result = await response.json();
      setAllBookingsTransport(result?.data);
      setLoader(false);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setLoader(false);
    }
  };

  useEffect(() => {
    customerHotelBookingsFetch();
  }, []);
  useEffect(() => {
    customerPacakgeBookingsFetch();
  }, []);
  useEffect(() => {
    customerActivityBookingsFetch();
  }, []);
  useEffect(() => {
    customerTransportBookingsFetch();
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const navigate = useNavigate();
  useEffect(() => {
    const userType = localStorage.getItem("userType");

    if (userType === "agent") {
      navigate("/agent-account");
    }
  }, [navigate]);
  const userToken = localStorage.getItem("token");

  const [customerDataa, setCustomerData] = useState(null);

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (userDetails) {
      setFormData(userDetails);
    }
  }, []);

  useEffect(() => {
    const role = queryParams.get("role") || "profile";
    setActiveTab(role);
  }, [location.search]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const profileFilter = (tab) => {
    setActiveTab(tab);
  };

  const fetchCustomerDetails = () => {
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/customer/user-profile`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setCustomerData(data.data);
          setFormData({
            name: data.data.name || "",
            phone: data.data.phone || "0",
            email: data.data.email || "",
          });
          localStorage.setItem("userDetails", JSON.stringify(data.data));
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      });
  };

  useEffect(() => {
    fetchCustomerDetails();
  }, []);

  const [isSliderVisible, setIsSliderVisible] = useState(false);

  const handleCloseSlider = () => {
    setIsSliderVisible(false);
  };

  // const fetchSidebarDetails = (bookingId) => {
  //   const myHeaders = new Headers();
  //   myHeaders.append("Accept", "application/json");
  //   myHeaders.append("key", process.env.REACT_APP_API_KEY);
  //   myHeaders.append(
  //     "Authorization",
  //     "Bearer " + localStorage.getItem("token")
  //   );
  //   const requestOptions = {
  //     method: "GET",
  //     headers: myHeaders,
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${process.env.REACT_APP_APP_URL}/api/v1/agents/single-booking/${bookingId}`,
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       if (result.success) {
  //         handleChangeClick();
  //         setSingleBookingData(result?.data);
  //       }
  //     })
  //     .catch((error) => console.error(error));
  // };

  const fetchSidebarDetails = async (bookingId) => {
    try {
      const myHeaders = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
        Cookie: process.env.REACT_APP_COOKIE,
      };
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/customer/bookings/fetch/single/${bookingId}`,
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            booking_type: "accommodation",
          }),
          redirect: "follow",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      if (result.success) {
        handleChangeClick();
        setSingleBookingData(result?.data);
      }
    } catch (error) {
      console.error("Error fetching booking details:", error);
      throw error; // Optional: rethrow the error if further handling is required
    }
  };

  const [selectedButton, setSelectedButton] = useState("Hotels");

  useEffect(() => {
    // setLoader(true); // Start loading before fetching

    switch (selectedButton) {
      case "Hotels":
        customerHotelBookingsFetch();
        break;
      case "Packages":
        customerPacakgeBookingsFetch();
        break;
      case "Activities":
        customerActivityBookingsFetch();
        break;
      case "Transport":
        customerTransportBookingsFetch();
        break;
      default:
        customerHotelBookingsFetch();
        setLoader(false);
        break;
    }
  }, [selectedButton]);

  const getSelectedBookings = () => {
    switch (selectedButton) {
      case "Hotels":
        return allBookingsHotels || [];
      case "Packages":
        return allBookingsPackages || [];
      case "Activities":
        return allBookingsActivities || [];
      case "Transport":
        return allBookingsTransport || [];
      default:
        return [];
    }
  };

  const query = new URLSearchParams(location.search);
  const role = query.get("role");
  const [activeTab, setActiveTab] = useState("Profile");

  useEffect(() => {
    if (role === "bookings") {
      setActiveTab("Bookings");
    } else {
      setActiveTab("Profile");
    }
  }, []);

  const buttonOptions = ["Hotels", "Packages", "Activities", "Transport"];
  const [isOpen, setIsOpen] = useState(false);

  const dummyBookings = [
    {
      id: 88,
      uuid: "e57858fe-a56e-4ad7-b8a8-1aaf9c2b1a97",
      name: null,
      leadId: null,
      quotationId: null,
      customerId: 10,
      agentId: null,
      customerDetails: {
        id: 10,
        name: "sad",
        email: "sfdaskjh@sad.com",
        phone: "9820498203",
        city: "Dubai",
        state: "Uttar Pradesh",
        address: "Dubai, Uttar Pradesh 209867, India",
        country: "India",
        zipcode: "90803",
      },
      bookingType: "accommodation",
      bookingNo: 5831026709,
      total: 3750,
      tax_details: [
        {
          rate: 12,
          amount: 450,
        },
      ],
      grandTotal: 4200,
      status: "cancelled",
      dueAmount: 4200,
      paidAmount: 0,
      scheduledAmount: 0,
      createdAt: "2024-12-27",
    },
    {
      id: 89,
      uuid: "b1b16c88-63a3-4619-8f54-18016d934e75",
      name: null,
      leadId: null,
      quotationId: null,
      customerId: 10,
      agentId: null,
      customerDetails: {
        id: 10,
        name: "sad",
        email: "sfdaskjh@sad.com",
        phone: "9820498203",
        city: "Dubai",
        state: "Uttar Pradesh",
        address: "Dubai, Uttar Pradesh 209867, India",
        country: "India",
        zipcode: "90803",
      },
      bookingType: "accommodation",
      bookingNo: 6377700826,
      total: 3750,
      tax_details: [
        {
          rate: 12,
          amount: 450,
        },
      ],
      grandTotal: 4200,
      status: "cancelled",
      dueAmount: 4200,
      paidAmount: 0,
      scheduledAmount: 0,
      createdAt: "2024-12-27",
    },
    {
      id: 90,
      uuid: "be2000e1-0fe7-4fef-8fe9-4b9594946e31",
      name: null,
      leadId: null,
      quotationId: null,
      customerId: 10,
      agentId: null,
      customerDetails: {
        id: 10,
        name: "sad",
        email: "sfdaskjh@sad.com",
        phone: "9820498203",
        city: "Dubai",
        state: "Uttar Pradesh",
        address: "Dubai, Uttar Pradesh 209867, India",
        country: "India",
        zipcode: "90803",
      },
      bookingType: "accommodation",
      bookingNo: 4287060191,
      total: 3750,
      tax_details: [
        {
          rate: 12,
          amount: 450,
        },
      ],
      grandTotal: 4200,
      status: "confirmed",
      dueAmount: 4200,
      paidAmount: 0,
      scheduledAmount: 0,
      createdAt: "2024-12-27",
    },
  ];

  const allBookingsCount = getSelectedBookings();

  // console.log(allBookingsCount, "allBookingsCount");

  return (
    <div id="Listingholidays">
      <PageMetaData
        title="Mountain Mysteries"
        description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        keywords="hotel management, RevCatalyst, property optimization"
      />
      <div className="sidebar_main_div new_sidebar_main_div">
        <CustomerSideBar />
        <div className="agent-info-container">
          <CustomerHeader />
          <section className="w-full">
            <div id="common_background_profile m_20">
              <section className="w-full mt-20">
                <div className={styles.agent_bookings_section}>
                  <div className="flex justify_content_between">
                    <div>
                      <h4>Bookings</h4>
                    </div>
                    <div className={styles.dropdownButtonFilter}>
                      <button onClick={() => setIsOpen(!isOpen)}>
                        {selectedButton}{" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="15"
                          viewBox="0 0 14 15"
                          fill="none"
                          style={{
                            transform: isOpen
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.3s ease",
                          }}
                        >
                          <mask
                            id="mask0_6855_8756"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="14"
                            height="15"
                          >
                            <rect
                              y="14.5"
                              width="14"
                              height="14"
                              transform="rotate(-90 0 14.5)"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_6855_8756)">
                            <path
                              d="M7.0008 9.14202L11.3949 4.74791C11.5108 4.63202 11.6472 4.57554 11.8043 4.57845C11.9614 4.58147 12.0979 4.64092 12.2138 4.75681C12.3296 4.87279 12.3876 5.00929 12.3876 5.16631C12.3876 5.32332 12.3296 5.45982 12.2138 5.57581L7.74791 10.0506C7.64242 10.156 7.52425 10.2342 7.39338 10.2851C7.26252 10.3359 7.13166 10.3613 7.0008 10.3613C6.86994 10.3613 6.73908 10.3359 6.60822 10.2851C6.47736 10.2342 6.35918 10.156 6.2537 10.0506L1.7788 5.57581C1.66291 5.45982 1.60648 5.32181 1.60949 5.16179C1.6125 5.00176 1.67195 4.8638 1.78784 4.74791C1.90373 4.63202 2.04023 4.57408 2.19734 4.57408C2.35436 4.57408 2.49081 4.63202 2.6067 4.74791L7.0008 9.14202Z"
                              fill="white"
                            />
                          </g>
                        </svg>
                      </button>

                      {isOpen && (
                        <ul className={styles.dropdownButtonFilterChild}>
                          {buttonOptions.map((option) => (
                            <li
                              key={option}
                              className=""
                              onClick={() => {
                                setSelectedButton(option);
                                setIsOpen(false);
                              }}
                            >
                              {option}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>

                  <div className={styles.total_bookings_sec}>
                    <div className={styles.total_bookings_sec_item}>
                      Total Bookings
                      <span>{allBookingsCount?.length}</span>
                    </div>
                    <div className={styles.total_bookings_sec_item}>
                      Confirmed
                      <span>
                        {
                          allBookingsCount?.filter(
                            (item) => item.status === "confirm"
                          ).length
                        }
                      </span>
                    </div>
                    <div className={styles.total_bookings_sec_item}>
                      Hold
                      <span>
                        {
                          allBookingsCount?.filter(
                            (item) => item.status === "hold"
                          ).length
                        }
                      </span>
                    </div>
                    <div className={styles.total_bookings_sec_item}>
                      Cancelled
                      <span>
                        {
                          allBookingsCount?.filter(
                            (item) => item.status === "cancelled"
                          ).length
                        }
                      </span>
                    </div>
                  </div>
                </div>

                {selectedButton === "Hotels" ? (
                  <div id="common_background_profile m_20 mt_10">
                    <div className="">
                      <div className="profile_content Bookings">
                        {allBookingsHotels?.length > 0 ? (
                          <>
                            <div className={styles.tableContainer}>
                              <div
                                className="overflow_x_scroll_y_hidden"
                                id="csv_download"
                              >
                                <table
                                  className="m_0 customTable"
                                  id="customTable"
                                >
                                  <thead>
                                    <tr>
                                      <th>Booking Number</th>
                                      <th>Email</th>
                                      <th>Phone No.</th>
                                      <th>Grand Total</th>
                                      <th>Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {allBookingsHotels.map((data, index) => (
                                      <tr key={index}>
                                        <td>
                                          <span
                                            onClick={() =>
                                              fetchSidebarDetails(data?.id)
                                            }
                                            className={styles.bookingNumber}
                                            style={{
                                              background: "transparent",
                                              border: "none",
                                              color: "#3968ED",
                                              padding: "0",
                                            }}
                                          >
                                            # {data?.bookingNo}
                                          </span>
                                          <p>{data?.customerDetails?.name}</p>
                                        </td>
                                        <td>
                                          {data?.customerDetails?.email ||
                                            "N/A"}
                                        </td>
                                        <td>
                                          {data?.customerDetails?.phone ||
                                            "N/A"}
                                        </td>
                                        <td>₹{data?.grandTotal}</td>
                                        <td>
                                          <span
                                            className={`${
                                              styles.tableStatus
                                            } text-capitalize ${
                                              data.status === "confirmed"
                                                ? styles.confirm
                                                : styles.cancelled
                                            }`}
                                          >
                                            {data?.status}
                                          </span>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>

                              {isSliderVisible && singleBookingData && (
                                <SeeBookingSlider
                                  singleBookingData={singleBookingData}
                                  onClose={handleCloseSlider}
                                  setIsSliderVisible={setIsSliderVisible}
                                />
                              )}
                            </div>
                          </>
                        ) : (
                          <NoDataFound />
                        )}
                      </div>
                    </div>
                  </div>
                ) : selectedButton === "Packages" ? (
                  // <AgentPackages
                  //   selectedButton={selectedButton}
                  //   setSelectedButton={setSelectedButton}
                  // />
                  <>
                    {loader ? (
                      <Loader size="4em" color="#016932" />
                    ) : allBookingsPackages?.length > 0 ? (
                      <>
                        <div className={styles.tableContainer}>
                          <div
                            className="overflow_x_scroll_y_hidden "
                            id="csv_download"
                          >
                            <table className="m_0 customTable" id="customTable">
                              <thead>
                                <tr>
                                  <th>Booking Number</th>
                                  <th>Email</th>
                                  <th>Tour Name</th>
                                  <th>Phone No.</th>
                                  <th>Grand Total</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {allBookingsPackages &&
                                  allBookingsPackages?.length > 0 &&
                                  allBookingsPackages?.map((data, index) => (
                                    <tr key={index}>
                                      <td>
                                        {" "}
                                        <span
                                          onClick={() =>
                                            fetchSidebarDetails(data?.id)
                                          }
                                          className={styles.bookingNumber}
                                          style={{
                                            background: "transparent",
                                            border: "none",
                                            color: "#3968ED",
                                            padding: "0",
                                          }}
                                        >
                                          # {data?.bookingNo}
                                        </span>{" "}
                                        <br />
                                      </td>
                                      <td>
                                        {data?.customerDetails?.email
                                          ? data?.customerDetails?.email
                                          : "N/A"}
                                      </td>
                                      <td>{data?.name ? data?.name : "N/A"}</td>
                                      <td>
                                        {" "}
                                        {data?.customerDetails?.phone
                                          ? data?.customerDetails?.phone
                                          : "N/A"}
                                      </td>
                                      <td>{data?.grandTotal}</td>
                                      <td>
                                        {" "}
                                        <span
                                          className={`${
                                            styles.tableStatus
                                          } text-capitalize ${
                                            data.status === "confirmed"
                                              ? styles.confirm
                                              : styles.cancelled
                                          }`}
                                        >
                                          {" "}
                                          {data?.status}
                                        </span>{" "}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>

                          {/* Booking Content End */}
                        </div>

                        {isSliderVisible && singleBookingData && (
                          <TourBookings
                            singleBookingData={singleBookingData}
                            onClose={handleCloseSlider}
                            setIsSliderVisible={setIsSliderVisible}
                          />
                        )}
                      </>
                    ) : (
                      <NoDataFound />
                    )}
                  </>
                ) : selectedButton === "Activities" ? (
                  <>
                    {loader ? (
                      <Loader size="4em" color="#016932" />
                    ) : allBookingsActivities?.length > 0 ? (
                      <>
                        <div className={styles.tableContainer}>
                          <div
                            className="overflow_x_scroll_y_hidden "
                            id="csv_download"
                          >
                            <table className="m_0 customTable" id="customTable">
                              <thead>
                                <tr>
                                  <th>Booking Number</th>
                                  <th>Email</th>
                                  <th>Tour Name</th>
                                  <th>Phone No.</th>
                                  <th>Grand Total</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {allBookingsActivities &&
                                  allBookingsActivities?.length > 0 &&
                                  allBookingsActivities?.map((data, index) => (
                                    <tr key={index}>
                                      <td>
                                        {" "}
                                        <span
                                          onClick={() =>
                                            fetchSidebarDetails(data?.id)
                                          }
                                          className={styles.bookingNumber}
                                          style={{
                                            background: "transparent",
                                            border: "none",
                                            color: "#3968ED",
                                            padding: "0",
                                          }}
                                        >
                                          # {data?.bookingNo}
                                        </span>{" "}
                                        <br />
                                      </td>
                                      <td>
                                        {data?.customerDetails?.email
                                          ? data?.customerDetails?.email
                                          : "N/A"}
                                      </td>
                                      <td>{data?.name ? data?.name : "N/A"}</td>
                                      <td>
                                        {" "}
                                        {data?.customerDetails?.phone
                                          ? data?.customerDetails?.phone
                                          : "N/A"}
                                      </td>
                                      <td>{data?.grandTotal}</td>
                                      <td>
                                        {" "}
                                        <span
                                          className={`${
                                            styles.tableStatus
                                          } text-capitalize ${
                                            data.status === "confirmed"
                                              ? styles.confirm
                                              : styles.cancelled
                                          }`}
                                        >
                                          {" "}
                                          {data?.status}
                                        </span>{" "}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>

                          {/* Booking Content End */}
                        </div>

                        {isSliderVisible && singleBookingData && (
                          <TourBookings
                            singleBookingData={singleBookingData}
                            onClose={handleCloseSlider}
                            setIsSliderVisible={setIsSliderVisible}
                          />
                        )}
                      </>
                    ) : (
                      <NoDataFound />
                    )}
                  </>
                ) : selectedButton === "Transport" ? (
                  <>
                    {loader ? (
                      <Loader size="4em" color="#016932" />
                    ) : allBookingsTransport?.length > 0 ? (
                      <>
                        <div className={styles.tableContainer}>
                          <div
                            className="overflow_x_scroll_y_hidden "
                            id="csv_download"
                          >
                            <table className="m_0 customTable" id="customTable">
                              <thead>
                                <tr>
                                  <th>Booking Number</th>
                                  <th>Email</th>
                                  <th>Tour Name</th>
                                  <th>Phone No.</th>
                                  <th>Grand Total</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {allBookingsTransport &&
                                  allBookingsTransport?.length > 0 &&
                                  allBookingsTransport?.map((data, index) => (
                                    <tr key={index}>
                                      <td>
                                        {" "}
                                        <span
                                          onClick={() =>
                                            fetchSidebarDetails(data?.id)
                                          }
                                          className={styles.bookingNumber}
                                          style={{
                                            background: "transparent",
                                            border: "none",
                                            color: "#3968ED",
                                            padding: "0",
                                          }}
                                        >
                                          # {data?.bookingNo}
                                        </span>{" "}
                                        <br />
                                      </td>
                                      <td>
                                        {data?.customerDetails?.email
                                          ? data?.customerDetails?.email
                                          : "N/A"}
                                      </td>
                                      <td>{data?.name ? data?.name : "N/A"}</td>
                                      <td>
                                        {" "}
                                        {data?.customerDetails?.phone
                                          ? data?.customerDetails?.phone
                                          : "N/A"}
                                      </td>
                                      <td>{data?.grandTotal}</td>
                                      <td>
                                        {" "}
                                        <span
                                          className={`${
                                            styles.tableStatus
                                          } text-capitalize ${
                                            data.status === "confirmed"
                                              ? styles.confirm
                                              : styles.cancelled
                                          }`}
                                        >
                                          {" "}
                                          {data?.status}
                                        </span>{" "}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>

                          {/* Booking Content End */}
                        </div>

                        {isSliderVisible && singleBookingData && (
                          <TourBookings
                            singleBookingData={singleBookingData}
                            onClose={handleCloseSlider}
                            setIsSliderVisible={setIsSliderVisible}
                          />
                        )}
                      </>
                    ) : (
                      <NoDataFound />
                    )}
                  </>
                ) : null}
              </section>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default CustomerBooking;
